import { UPLOADERS_EVENTS } from '../event_bus_modules/uploaders';

const COMPONENT = 'file-uploader';

const FILE_FORMATS = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'application/pdf',
];

const CSS_CLASS = {
  DISPLAY_NONE: 'd-none',
  DOT: 'dot',
  ACTIVE: 'active',
};

// 5MB
const FILE_MAX_SIZE = 5242880;

const initializeFileHandler = ({
  fileInputElement,
  uploadEndpoint,
  removeEndpoint,
  csrfToken,
  isMakeAnOfferFile,
}) => {
  const ELEMENT = fileInputElement;
  const thisId = ELEMENT.attr('id');

  const SELECTORS = {
    DROP_AREA: ELEMENT.find(`.${COMPONENT}__drop-area`),
    DROP_AREA_WRAPPER: ELEMENT.find(`.${COMPONENT}__drop-area-wrapper`),
    DROP_AREA_INPUT: ELEMENT.find(`.${COMPONENT}__drop-area input`),
    DROP_AREA_TEXT_DEFAULT: ELEMENT.find(
      `.${COMPONENT}__drop-area-label--default`
    ),
    DROP_AREA_TEXT_FIELD_HELD: ELEMENT.find(
      `.${COMPONENT}__drop-area-label--file-held`
    ),
    UPLOAD_PHOTO_BUTTON: ELEMENT.find(`.${COMPONENT}__upload-photo-button`),
    IMAGE_PREVIEW_WRAPPER: ELEMENT.find(`.${COMPONENT}__preview`),
    IMAGE_PDF_FILE_ICON: ELEMENT.find(`.${COMPONENT}__pdf-file`),
    IMAGE_PREVIEW_REMOVE_BUTTON: ELEMENT.find(`.${COMPONENT}__preview-remove`),
    FILE_ERROR_FORMAT: ELEMENT.find('.error-file-format'),
    FILE_ERROR_SIZE: ELEMENT.find('.error-file-size'),
    MESSAGE: ELEMENT.find(`.${COMPONENT}__message`),
    PREVIEW_MESSAGE: ELEMENT.find(`.${COMPONENT}__success-message`),
    INPUT_SECTION: ELEMENT.find(`.${COMPONENT}__inputs-section`),
    UPLOADED_FILE: ELEMENT.find(`.${COMPONENT}__uploaded-file`),
    EXPIRATION_DATE_FIELD: ELEMENT.siblings('div.form-row').find('input'),
    EXPIRATION_DATE_FIELD_ERRORS: ELEMENT.siblings('div.form-row').find(
      "[id$='-error-section']"
    ),
  };

  ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
    SELECTORS.DROP_AREA.on(eventName, preventDefaults);
  });

  ['dragenter', 'dragover'].forEach((eventName) => {
    SELECTORS.DROP_AREA.on(eventName, dropAreaEntered);
  });

  ['dragleave', 'drop'].forEach((eventName) => {
    SELECTORS.DROP_AREA.on(eventName, dropAreaLeft);
  });

  function dropAreaEntered() {
    SELECTORS.DROP_AREA_TEXT_DEFAULT.addClass(CSS_CLASS.DISPLAY_NONE);
    SELECTORS.DROP_AREA_TEXT_FIELD_HELD.removeClass(CSS_CLASS.DISPLAY_NONE);
  }

  function dropAreaLeft() {
    SELECTORS.DROP_AREA_TEXT_DEFAULT.removeClass(CSS_CLASS.DISPLAY_NONE);
    SELECTORS.DROP_AREA_TEXT_FIELD_HELD.addClass(CSS_CLASS.DISPLAY_NONE);
  }

  function hideDropArea() {
    SELECTORS.DROP_AREA_WRAPPER.addClass(CSS_CLASS.DISPLAY_NONE);
  }

  function showDropArea() {
    SELECTORS.DROP_AREA_WRAPPER.removeClass(CSS_CLASS.DISPLAY_NONE);
  }

  function showInputSection() {
    SELECTORS.INPUT_SECTION.removeClass(CSS_CLASS.DISPLAY_NONE);
  }

  function hideTakePhoto() {
    SELECTORS.UPLOAD_PHOTO_BUTTON.addClass(CSS_CLASS.DISPLAY_NONE);
  }

  function hideUploadedFile() {
    SELECTORS.UPLOADED_FILE.addClass(CSS_CLASS.DISPLAY_NONE);
  }

  function showTakePhoto() {
    SELECTORS.UPLOAD_PHOTO_BUTTON.removeClass(CSS_CLASS.DISPLAY_NONE);
  }

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const dropHandler = ($event) => {
    resetErrors();
    const fieldName = $event.target.getAttribute('data-name');
    const dataTransfer = $event.originalEvent?.dataTransfer || $event.target;
    // To be considered if only a single file should be processed
    const file = dataTransfer.files[0];
    if (validateFile(file)) {
      previewFile(file);
      hideDropArea();
      hideTakePhoto();
      hideUploadedFile();
      SELECTORS.PREVIEW_MESSAGE.html('');
      SELECTORS.IMAGE_PREVIEW_WRAPPER.switchClass('d-none', 'd-flex');
      displayResponseMessage('', 'success');
      requestImageUpload(fieldName, file);
    }
  };

  const validateFile = (file) => {
    if (!FILE_FORMATS.includes(file.type)) {
      setFileFormatError();
      return false;
    }
    if (FILE_MAX_SIZE < file.size) {
      setFileSizeError();
      return false;
    }
    return true;
  };

  const setFileSizeError = () => {
    SELECTORS.FILE_ERROR_SIZE.removeClass(CSS_CLASS.DISPLAY_NONE);
  };

  const setFileFormatError = () => {
    SELECTORS.FILE_ERROR_FORMAT.removeClass(CSS_CLASS.DISPLAY_NONE);
  };

  const previewFile = (file) => {
    if (file.type === 'application/pdf') {
      SELECTORS.IMAGE_PDF_FILE_ICON.removeClass(CSS_CLASS.DISPLAY_NONE);
      let paragraph = document.createElement('strong');
      paragraph.textContent = file.name;
      SELECTORS.IMAGE_PREVIEW_WRAPPER.append(paragraph);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        let img = document.createElement('img');
        let paragraph = document.createElement('strong');
        img.src = reader.result;
        img.alt = file.name;
        SELECTORS.IMAGE_PREVIEW_WRAPPER.append(img);
        paragraph.textContent = file.name;
        SELECTORS.IMAGE_PREVIEW_WRAPPER.append(paragraph);
      };
    }
  };

  const resetErrors = () => {
    SELECTORS.FILE_ERROR_SIZE.addClass(CSS_CLASS.DISPLAY_NONE);
    SELECTORS.FILE_ERROR_FORMAT.addClass(CSS_CLASS.DISPLAY_NONE);
  };

  const displayResponseMessage = (message, messageType) => {
    if (message !== '') {
      SELECTORS.MESSAGE.html(message)
        .addClass(messageType)
        .switchClass('d-none', 'd-flex');
    }
  };

  const onFileUploaded = (message) => {
    SELECTORS.PREVIEW_MESSAGE.html(message);
    SELECTORS.IMAGE_PREVIEW_REMOVE_BUTTON.switchClass('d-none', 'd-flex');
  };

  const onFileRemoved = (message) => {
    SELECTORS.IMAGE_PDF_FILE_ICON.addClass(CSS_CLASS.DISPLAY_NONE);
    const image = SELECTORS.IMAGE_PREVIEW_WRAPPER.find('img');
    const name = SELECTORS.IMAGE_PREVIEW_WRAPPER.find('strong');
    image.remove();
    name.remove();
    showDropArea();
    showTakePhoto();
    showInputSection();
    displayResponseMessage(message, 'success');
    // Reset the expiration date field input
    SELECTORS.EXPIRATION_DATE_FIELD.val('');
    SELECTORS.EXPIRATION_DATE_FIELD_ERRORS.switchClass('d-flex', 'd-none');
    // Remove input value together with image
    SELECTORS.DROP_AREA_INPUT.val('');
    SELECTORS.IMAGE_PREVIEW_WRAPPER.switchClass('d-flex', 'd-none');
  };

  const onImageRemoveClicked = ($event) => {
    SELECTORS.IMAGE_PREVIEW_REMOVE_BUTTON.switchClass('d-flex', 'd-none');
    requestImageRemoval($event);
  };

  const requestImageRemoval = ($event) => {
    $event.preventDefault();
    if (isMakeAnOfferFile) {
      EVENT_BUS.dispatch(UPLOADERS_EVENTS.FILE_REMOVED, {
        id: thisId,
        message: 'File removed.',
      });
    } else {
      EVENT_BUS.dispatch(UPLOADERS_EVENTS.REMOVE_FILE, {
        id: thisId,
        removeEndpoint,
        csrfToken,
      });
    }
  };

  const requestImageUpload = (fieldName, file) => {
    const values = { [fieldName]: file, is_make_an_offer: isMakeAnOfferFile };
    EVENT_BUS.dispatch(UPLOADERS_EVENTS.UPLOAD_FILE, {
      id: thisId,
      values,
      uploadEndpoint,
      csrfToken,
    });
  };

  SELECTORS.DROP_AREA.on('drop', dropHandler);
  SELECTORS.DROP_AREA_INPUT.on('change', dropHandler);
  SELECTORS.IMAGE_PREVIEW_REMOVE_BUTTON.on('click', onImageRemoveClicked);
  SELECTORS.UPLOAD_PHOTO_BUTTON.on('drop', dropHandler);
  SELECTORS.UPLOAD_PHOTO_BUTTON.on('change', dropHandler);

  EVENT_BUS.on(UPLOADERS_EVENTS.FILE_REMOVED, ({ id, message }) => {
    if (thisId == id) {
      onFileRemoved(message);
    }
  });

  EVENT_BUS.on(UPLOADERS_EVENTS.FILE_UPLOADED, ({ id, message }) => {
    if (thisId == id) {
      onFileUploaded(message);
    }
  });

  EVENT_BUS.on(UPLOADERS_EVENTS.FILE_REMOVE_ERROR, ({ id, message }) => {
    if (thisId == id) {
      displayResponseMessage(message, 'error');
    }
  });

  EVENT_BUS.on(UPLOADERS_EVENTS.FILE_UPLOAD_ERROR, ({ id, message }) => {
    if (thisId == id) {
      displayResponseMessage(message, 'error');
    }
  });

  $(window).on('unload', () => {
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
      SELECTORS.DROP_AREA.off(eventName, preventDefaults);
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      SELECTORS.DROP_AREA.off(eventName, dropAreaEntered);
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      SELECTORS.DROP_AREA.off(eventName, dropAreaLeft);
    });

    SELECTORS.DROP_AREA.off('drop', dropHandler);
    SELECTORS.DROP_AREA_INPUT.off('change', dropHandler);
    SELECTORS.IMAGE_PREVIEW_REMOVE_BUTTON.off('click', onImageRemoveClicked);
    SELECTORS.UPLOAD_PHOTO_BUTTON.off('drop', dropHandler);
    SELECTORS.UPLOAD_PHOTO_BUTTON.off('change', dropHandler);
  });
};

export const initializeInstantFileUploaders = ({
  container,
  elementsIds,
  csrfTokenElement,
  uploadEndpoint,
  removeEndpoint,
  isMakeAnOfferFile,
}) => {
  elementsIds.forEach((elementId) => {
    const fileInputElement = $(`${container} #${elementId}`);
    const csrfToken = $(
      `${csrfTokenElement} input[name="csrfmiddlewaretoken"]`
    ).val();
    initializeFileHandler({
      fileInputElement,
      uploadEndpoint,
      removeEndpoint,
      csrfToken,
      isMakeAnOfferFile,
    });
  });
};
